import * as yup from "yup";

import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

import accountStatusSchema from "./accountStatus";
import profileSchema from "./profile";
import agentSchema from "./agent";

const fullSchema = yup.object({
  id: yup.string().nullable(),
  roles: yup.array().of(yup.string()), // TODO: Enforce stricter role validation
  sso: yup.object({
    sso_id: yup.string().nullable(),
    sso_username: yup.string().nullable(),
  }),
  account_status: accountStatusSchema,
  profile: profileSchema,
  agent: agentSchema,
});

addKeyToFieldsRecursively(fullSchema);
export default fullSchema;
